import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=83ff9f8a&scoped=true"
import script from "./deal.vue?vue&type=script&lang=js"
export * from "./deal.vue?vue&type=script&lang=js"
import style0 from "./deal.vue?vue&type=style&index=0&id=83ff9f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ff9f8a",
  null
  
)

export default component.exports